import React from 'react'
import { connect } from 'kea'

import courseLogic from '~/scenes/course/show/logic'

export default connect({
  actions: [courseLogic, ['setHoverLocation']],
  props: [courseLogic, ['course', 'hoverLocation']]
})(({ course: { locations }, hoverLocation, actions: { setHoverLocation }, onClick }) => (
  <div>
    {locations.map(l => (
      <div
        key={l.id}
        onMouseEnter={() => setHoverLocation(l.id)}
        onMouseLeave={() => setHoverLocation(null)}
        onClick={() => onClick(l)}
        className={`cursor-pointer small-pin ${
          l.type === 'in_house' ? 'orange' : l.type === 'in_studio' ? 'green' : 'webcam'
        } ${hoverLocation === l.id ? 'hover' : ''}`}
      >
        {l.title}
      </div>
    ))}
  </div>
))
